import { AxiosInstance } from 'axios';

import { IProfile } from 'src/views/Admin/Profiles/types';
import { insertId } from '../../insertId';
import { toResponse } from '../../genericToResponse';
import { cancellable } from '../../cancellable';

export default (api: AxiosInstance, url: string) => (id?: number) => {
  const urlWithId = id ? insertId(url, id) : url;
  return cancellable<IProfile[]>(
    (cancelOptions: any) => api.get(urlWithId, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/admin/profiles/get.ts